export const statusColorForBooking = (
	status: string,
): 'green' | 'orange' | 'blue' | 'red' | 'gray' => {
	if (status === 'pending') return 'orange';
	if (status === 'confirmed') return 'blue';
	if (status === 'completed') return 'green';
	if (status === 'canceled') return 'red';
	return 'gray';
};

export const statusLabelForBooking = (status: string): string => {
	if (status === 'pending') return 'Pending';
	if (status === 'confirmed') return 'Confirmed';
	if (status === 'completed') return 'Completed';
	if (status === 'canceled') return 'Canceled';
	return 'Unknown';
};
